import Banner from "../components/ContactScreen/Banner";
import ContactInfo from "../components/ContactScreen/ContactInfo";
import ContactForm from "../components/ContactScreen/ContactForm";

export default function ContactPage() {
	return (
		<div>
			<Banner />
			<ContactInfo />
			<ContactForm />
			<iframe
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.7530473671122!2d-98.22573582015514!3d19.03060063617739!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc0cace5f4cc5%3A0x6942ea299894243f!2sSan%20Miguel%2C%20Reforma%20Agua%20Azul%2C%2072430%20Heroica%20Puebla%20de%20Zaragoza%2C%20Pue.!5e0!3m2!1ses!2smx!4v1765911741297!5m2!1ses!2smx"
				className="border-0 w-full h-96"
				allowfullscreen=""
				loading="lazy"
				referrerpolicy="no-referrer-when-downgrade"
				title="mapa"
			></iframe>
		</div>
	);
}
